module.exports = __webpack_public_path__ + "img/CYhludL.864c3326.jpg";